import { useServices } from 'core/services';
import { communityKeys } from 'core/utils/query-key-factory';
import { useQuery } from '@tanstack/react-query';

export const useGetCommunityTransferRequests = (communityId: string) => {
	const { api } = useServices();

	return useQuery({
		queryKey: communityKeys.transferRequests(communityId),
		queryFn: () =>
			api
				.getTransferOwnershipRequests(communityId)
				.then(response => response.data),
		enabled: !!communityId,
		refetchOnMount: true,
	});
};
